import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CookieStateService {
    read(name: string): string | null {
        const prefix = `${name}=`;
        const parts = document.cookie.split(';');
        for (const part of parts) {
            const cookie = part.trim();
            if (cookie.startsWith(prefix)) {
                return decodeURIComponent(cookie.slice(prefix.length));
            }
        }
        return null;
    }

    write(name: string, value: string, days: number): void {
        const maxAge = days * 24 * 60 * 60;
        document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
    }

    readJson<T>(name: string): T | null {
        const raw = this.read(name);
        if (!raw) return null;
        try {
            return JSON.parse(raw) as T;
        } catch {
            return null;
        }
    }

    writeJson(name: string, value: unknown, days: number): void {
        this.write(name, JSON.stringify(value), days);
    }
}
